/* autogen in tsEmplate_retina for emoji */
export var Emoji = {
  "angry": "emoji--angry",
  "astonished": "emoji--astonished",
  "awkward": "emoji--awkward",
  "blush": "emoji--blush",
  "bookworm": "emoji--bookworm",
  "bye": "emoji--bye",
  "cash": "emoji--cash",
  "catch_cold": "emoji--catch-cold",
  "chess_commander": "emoji--chess-commander",
  "clap": "emoji--clap",
  "contempt": "emoji--contempt",
  "covet": "emoji--covet",
  "decline": "emoji--decline",
  "disappointed": "emoji--disappointed",
  "doubt": "emoji--doubt",
  "finger_come": "emoji--finger-come",
  "finger_love_you": "emoji--finger-love-you",
  "finger_no": "emoji--finger-no",
  "finger_ok": "emoji--finger-ok",
  "finger_yeah": "emoji--finger-yeah",
  "gelivable": "emoji--gelivable",
  "giddy": "emoji--giddy",
  "go_crazy": "emoji--go-crazy",
  "go_mad": "emoji--go-mad",
  "greedy": "emoji--greedy",
  "grimace": "emoji--grimace",
  "hand_come_on": "emoji--hand-come-on",
  "hank_shake": "emoji--hank-shake",
  "happy": "emoji--happy",
  "heart_broken": "emoji--heart-broken",
  "heart_unbroken": "emoji--heart-unbroken",
  "hiss": "emoji--hiss",
  "hum_left": "emoji--hum-left",
  "hum_right": "emoji--hum-right",
  "hum": "emoji--hum",
  "ill": "emoji--ill",
  "kiss": "emoji--kiss",
  "laugh_with_teeth": "emoji--laugh-with-teeth",
  "laugh": "emoji--laugh",
  "love_you": "emoji--love-you",
  "lovely": "emoji--lovely",
  "not_bother_you": "emoji--not-bother-you",
  "pick_nose": "emoji--pick-nose",
  "pig": "emoji--pig",
  "pitiful": "emoji--pitiful",
  "rage": "emoji--rage",
  "red_packet": "emoji--red-packet",
  "shut_up": "emoji--shut-up",
  "sick": "emoji--sick",
  "sinister": "emoji--sinister",
  "sleep": "emoji--sleep",
  "sleepy": "emoji--sleepy",
  "smile": "emoji--smile",
  "sun_glasses": "emoji--sun-glasses",
  "sweat": "emoji--sweat",
  "tears": "emoji--tears",
  "think": "emoji--think",
  "thumb_down": "emoji--thumb-down",
  "thumb_up_support": "emoji--thumb-up-support",
  "thumb_up": "emoji--thumb-up",
  "titter": "emoji--titter",
  "weep": "emoji--weep",
  "withstand_pressure": "emoji--withstand-pressure",
  "wronged": "emoji--wronged",
  "yawn": "emoji--yawn"
};